import { Button, IconButton, styled, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { COLORS } from 'shared/constants/COLORS';
const { ERROR_ICON, DARK_TOP_NAV, LIGHT_TOP_NAV } = COLORS;
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      backgroundColor: theme.palette.type === 'dark' ? DARK_TOP_NAV : LIGHT_TOP_NAV,
      boxShadow: 'none',
      borderBottom:
        theme.palette.type === 'dark' ? '1px solid rgba(255, 255, 255, 0.12)' : `2px solid ${COLORS.LIGHT_BORDER}`,
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      [theme.breakpoints.up('sm')]: {
        marginLeft: 115,
        width: 'calc(100% - 115px)',
      },
    },
    appBarShift: {
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      [theme.breakpoints.up('sm')]: {
        marginLeft: 115,
        width: 'calc(100% - 115px)',
      },
    },
    menuButton: {
      [theme.breakpoints.up('sm')]: {
        display: 'none',
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
      },
    },
    search: {
      position: 'relative',
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
      },
    },
    searchIcon: {
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inputRoot: {
      color: 'inherit',
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    getHelpBtn: {
      border: '1px solid',
      borderColor: 'rgba(62, 139, 255, 0.5)',
      background: 'transparent',
      color: COLORS.PRIMARY,
      padding: '5px 15px',
      fontSize: '13px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '4px',
      textDecoration: 'none',
      fontWeight: 500,
      marginRight: 15,

      '&:hover': {
        borderColor: COLORS.PRIMARY,
      },
    },
    browserWarning: {
      backgroundColor: '#FFC107',
      padding: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#000',
      position: 'relative',
      fontSize: 15,
      fontWeight: 'bold',

      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
        display: 'block',
        padding: '10px 30px 10px 10px',
      },
    },
    browserWarningCloseBtn: {
      position: 'absolute',
      top: '50%',
      right: 20,
      transform: 'translateY(-50%)',
      padding: 7,

      [theme.breakpoints.down('sm')]: {
        right: 5,
        fontSize: 8,
      },
      fontSize: 16,
      '& svg': {
        '& path': {
          fill: '#000',
        },
      },
    },
    downloadChromeBtn: {
      [theme.breakpoints.down('sm')]: {
        fontSize: 10,
      },
      fontSize: 18,
    },
  }),
);

export const CustomIconButton = styled(IconButton)(({ theme, isLogout }: any) => ({
  height: '60px',
  minWidth: '60px',
  // borderLeft: 'solid 1px #1b2027',
  borderLeft: '1px solid',
  borderLeftColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : '#cdd9e9',
  borderRadius: 0,
  '& svg': {
    width: '21px',
  },
  '& svg path': {
    fill: isLogout ? ERROR_ICON : theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK_GRAY,
  },
}));

export const UserContainerButton = styled(Button)<Theme, { isActive?: boolean }>(({ isActive = false, theme }) => ({
  // backgroundColor: '#0d1117',
  backgroundColor: 'transparent',
  width: 251,
  borderRadius: 0,
  // borderLeft: '1px solid #1b2027',
  borderLeft: '1px solid',
  borderLeftColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : '#cdd9e9',
  borderBottom: isActive ? '2px solid #3e8bff' : '2px solid transparent',
  paddingTop: 2,
  position: 'relative',
  '& .MuiButton-label': {
    justifyContent: 'space-between',
  },
  // padding: '0 15px',
  // height: '60px',
  // minWidth: '60px !important',
  // borderRadius: 0,
  // borderLeft: 'solid 1px #1b2027',
  // '& > span:first-child': {
  //   display: 'flex',
  //   flexDirection: 'row',
  //   flexWrap: 'nowrap',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   color: '#EEEEEE',
  //   // '& > div': {
  //   //   marginLeft: '10px',
  //   //   height: '34px',
  //   //   width: '34px',
  //   //   overflow: 'hidden',
  //   //   borderRadius: '5px',
  //   //   background: '#808080',
  //   // },
  // },
}));

export const BackButton = styled(IconButton)(({ theme }) => ({
  height: '60px',
  minWidth: '60px',
  // borderRightColor: '#1b2027',
  // borderRight: 'solid 1px',
  borderRight: '1px solid',
  borderRightColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : '#cdd9e9',
  borderRadius: 0,
  '& svg': {
    width: '21px',
  },
}));
